import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import Topbar from "../../layouts/topbar";
import Webmenu from "../../layouts/webmenu";
import Toast from "../../components/Toast";
import { saveSupplier } from "../../actions/SupplierActions";
import Mobilemenu from "../../layouts/mobile-menu";

function AddSupplier() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [phone, setPhone] = useState('');
    const [fax, setFax] = useState('');
    const [trn_number, setTrn] = useState('');
    const [address, setAddress] = useState('');
    const [website, setWebsite] = useState('');
    const loading = useSelector(state => state?.loading?.loading);

    const save = () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else if (mobile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Mobile No. is Required!'
            })
        }
        else {
            let data = {
                name: name,
                email: email,
                phone: phone,
                mobile: mobile,
                fax: fax,
                trn_number: trn_number,
                address: address,
                // website: website,
            }
            dispatch(saveSupplier(data, navigate));
        }
        // window.location.href = ('/state');
    }
    const [isEmailValid, setIsEmailValid] = useState(true);

    const handleChangeEmail = (e) => {
        setEmail(e.target.value);

        // Validate the email format
        const isValidEmail = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(e.target.value);
        setIsEmailValid(isValidEmail);
    };

    const [isNameValid, setIsNameValid] = useState(true);

    const handleChangeName = (e) => {
        setName(e.target.value);

        // Validate the name format (no numbers allowed)
        const isValidName = /^[a-zA-Z\s]*$/.test(e.target.value);
        setIsNameValid(isValidName);
    };

    const [isMobileValid, setIsMobileValid] = useState(true);

    const handleChangeMobile = (e) => {

        setMobile(e.target.value);

        // Validate the phone number format
        const isMobileValid = /^[0-9]*$/.test(e.target.value);
        setIsMobileValid(isMobileValid);
    };

    const [isPhoneValid, setIsPhoneValid] = useState(true);
    const handleChangePhone = (e) => {
        setPhone(e.target.value);

        // Validate the phone number format
        const isValidPhone = /^[0-9]*$/.test(e.target.value);
        setIsPhoneValid(isValidPhone);
    };

    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <div className="intro-y d-flex align-items-center mt-8">
                        <h2 className="fs-lg fw-medium me-auto">
                            Add Supplier
                        </h2>
                    </div>
                    <div className="grid columns-12 gap-6 mt-5">
                        <div className="intro-y g-col-12">
                            {/* <!-- BEGIN: Form Layout --> */}
                            <div className="intro-y box p-5">
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="name" className="form-label">Name :</label>
                                        <input id="name" name="name" value={name} onChange={(e) => handleChangeName(e)} type="text" className={`form-control ${isNameValid ? '' : 'is-invalid'}`} placeholder="Enter Name" />
                                        {isNameValid == false && <div className="invalid-feedback">Please enter a valid name without numbers.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="email" className="form-label">Email :</label>
                                        <input id="email" name="email" type="text" value={email} onChange={(e) => handleChangeEmail(e)} className={`form-control ${isEmailValid ? '' : 'is-invalid'}`} placeholder="Enter Email" />
                                        {!isEmailValid && <div className="invalid-feedback">Please enter a valid email address.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="mobile" className="form-label">Mobile :</label>
                                        <input id="mobile" name="mobile" type="text" value={mobile} onChange={(e) => handleChangeMobile(e)} className={`form-control ${isMobileValid ? '' : 'is-invalid'}`} placeholder="Enter Mobile No." />
                                        {!isMobileValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}

                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="phone" className="form-label">Phone :</label>
                                        <input id="phone" name="phone" type="text" value={phone} onChange={(e) => handleChangePhone(e)} className={`form-control ${isPhoneValid ? '' : 'is-invalid'}`} placeholder="Enter Phone No." />
                                        {!isPhoneValid && <div className="invalid-feedback">Please enter a valid phone without alphabets.</div>}
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="fax" className="form-label">FAX :</label>
                                        <input id="fax" name="fax" type="text" onChange={(e) => setFax(e.target.value)} className="form-control" placeholder="Enter FAX" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="trn" className="form-label">TRN# :</label>
                                        <input id="trn" name="trn" type="text" onChange={(e) => setTrn(e.target.value)} className="form-control" placeholder="Enter TRN#" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="address" className="form-label">Address :</label>
                                        <input id="address" name="address" type="text" onChange={(e) => setAddress(e.target.value)} className="form-control" placeholder="Enter Address" />
                                    </div>
                                    {/* <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="website" className="form-label">Website :</label>
                                        <input id="website" name="website" type="text" onChange={(e) => setWebsite(e.target.value)} className="form-control" placeholder="Enter Website" />
                                    </div> */}
                                </div>
                                <div className="text-end mt-5">
                                    <button type="button" onClick={() => navigate('/suppliers')} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                    <button onClick={save} type="button" disabled={loading ? true : false} className="btn btn-primary w-24 ms-2">Save</button>
                                </div>
                            </div>
                            {/* <!-- END: Form Layout --> */}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddSupplier;